<template>

</template>

<script>
import { Popup } from 'vant'
import { hint, replenish, VInput } from '@/components/common'
import Vue from 'vue'

Vue.use(Popup)
export default {
  data () {
    return {
      weight: '',
      height: ''
    }
  },
  components: {VInput},

  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: []
    },
    btnList: {
      type: Array,
      default: []
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  watch: {},
  methods: {
    //    processing(text){
    //      return text
    //    },
    btnClick (index) {
      this.$emit('btnClick', index)
    },
    maskClicked (e) {
      this.$emit('btnClick', e)
    }
  }
//  name: 'showKnowledge'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

</style>
